import {roundTrackTime} from 'powtoon-html-studio/src/common/utils/timeStep'
import {getMinTimeStep} from 'powtoon-html-studio/src/common/utils/timeStep'

export const updatePlaybackSettings = ({
  track,
  trackNewStartTime,
  trackNewEndTime,
  videoDuration,
  playbackSettings,
  isVoiceoverLogicActive,
  preservePlaybackSettingsEndTime
}) => {
  const {endTime: trackCurrentEndTime, startTime: trackCurrentStartTime} =  track
  const {endTime: psEndTime, startTime: psStartTime} = playbackSettings
  
  if (!(playbackSettings && videoDuration)) {
    // no relevent data
    return playbackSettings
  }
  
  const isMeaningfulChangeStartTime = Math.abs(trackNewStartTime - trackCurrentStartTime) >0.02
  const isMeaningfulChangeEndTime = Math.abs(trackNewEndTime - trackCurrentEndTime) >0.02
  if (isMeaningfulChangeStartTime && isMeaningfulChangeEndTime)
  {
    // draging action not supose to change playbackSettings
    return playbackSettings
  }
  const {startTime: newStartTime} = getStartTime({
    psStartTime,
    trackCurrentStartTime,
    trackNewStartTime,
    isVoiceoverLogicActive
  })

  const {endTime: newEndTime} = getEndTime({
    psEndTime,
    trackCurrentEndTime,
    trackNewEndTime,
    trackNewStartTime,
    videoDuration,
    isVoiceoverLogicActive,
    trackCurrentStartTime,
    preservePlaybackSettingsEndTime
  })
  const timeLineStepSize = getMinTimeStep()
  const diffTimeSpanToSmall = newEndTime - newStartTime < timeLineStepSize
  const startTimeIncrement =  trackCurrentStartTime < trackNewStartTime

  const reAdjustedStartTime = diffTimeSpanToSmall && startTimeIncrement ?
    newEndTime - timeLineStepSize :
    newStartTime
  const reAdjustedEndTime = diffTimeSpanToSmall && !startTimeIncrement ?
    newStartTime + timeLineStepSize :
    newEndTime

  return {
    ...playbackSettings,
    endTime: reAdjustedEndTime,
    startTime: reAdjustedStartTime
  }
}

export const getDefaultVideoPlaybackSettings = (data, startTime, endTime) => ({
  startTime: 0,
  endTime: getDefaultEndTime(data, startTime, endTime),
  isMuted: false
})

export const getEndTime = ({
  psEndTime,
  trackCurrentEndTime = 1, trackNewEndTime = 1,
  videoDuration, isVoiceoverLogicActive = false,
  trackNewStartTime, trackCurrentStartTime, preservePlaybackSettingsEndTime
}) => {
  
  let calculatedEndTime = psEndTime
  const deltaStartTime = Math.abs(trackCurrentStartTime - trackNewStartTime)
  const deltaEndTime =  Math.abs(trackCurrentEndTime - trackNewEndTime)
  
  if (deltaEndTime || deltaStartTime){
    if (!isVoiceoverLogicActive){
      calculatedEndTime = trackNewEndTime > trackCurrentEndTime?
        psEndTime + deltaEndTime:
        preservePlaybackSettingsEndTime ? psEndTime : psEndTime - deltaEndTime

    } else {
      const trackDurationBiggerThanAssetDuration = Math.abs(trackNewEndTime - trackNewStartTime) > videoDuration
      const playbackEndTimeBiggerThanDuration = psEndTime > videoDuration
      const isSetAssetDuration = trackDurationBiggerThanAssetDuration || playbackEndTimeBiggerThanDuration
      if (isSetAssetDuration ){
        calculatedEndTime = videoDuration
      }
      else {
        const oldDuration = trackCurrentEndTime - trackCurrentStartTime
        const wasDurationSmallerThenOldEndTime =  oldDuration > videoDuration
          
        if (deltaEndTime){
          const refinedDeltaEndTime = wasDurationSmallerThenOldEndTime?
            deltaEndTime - (oldDuration - videoDuration)  :
            deltaEndTime

          calculatedEndTime = trackNewEndTime > trackCurrentEndTime ?
            psEndTime + deltaEndTime :
            psEndTime - refinedDeltaEndTime // the bug is here
        }
        if (deltaStartTime) {
          const refinedDeltaStartTime = wasDurationSmallerThenOldEndTime?
            deltaStartTime - (oldDuration - videoDuration)  :
            deltaStartTime
          calculatedEndTime = trackNewStartTime > trackCurrentStartTime ?
            psEndTime - refinedDeltaStartTime :
            psEndTime + deltaStartTime
        }
      }
      return {
        endTime: Math.max( Math.min(calculatedEndTime, videoDuration), 0)
      }
    }
  }
  return {
    endTime: Math.max( Math.min(roundTrackTime(calculatedEndTime), videoDuration), 0)
  }
}
const getDefaultEndTime = (data, startTime = 0, endTime = 1) => {
  return getValidEndTime(endTime - startTime, data?.videoData?.duration)
}

export const getValidEndTime = (trackNewDuration = 0, videoDataDuration= 0) =>
  Math.min(Math.max(trackNewDuration, 0), videoDataDuration)

export const getStartTime = ({
  psStartTime, trackCurrentStartTime = 0,
  trackNewStartTime, isVoiceoverLogicActive
}) => {

  if (isVoiceoverLogicActive){
    // on VoiceOver time line the left handle wont effect  playbackSettings.startTime only the endTime
    // see VCP-732 LipSync - Timeline behavior update
    return {
      startTime: 0
    }
  }
  const deltaStartTime = Math.abs( trackCurrentStartTime - trackNewStartTime) || 0
  const calculatedStartTime = trackCurrentStartTime > trackNewStartTime?
    psStartTime - deltaStartTime:
    psStartTime + deltaStartTime

  return {
    startTime: Math.max( roundTrackTime(calculatedStartTime), 0)
  }
}

